import { createMongoAbility } from '@casl/ability'
import { initialAbility } from './initialAbility'

// Read ability rules from localStorage (set after login).
// Falls back to `initialAbility` for the unauthenticated case.
const data = localStorage.getItem('userData')
const userData = data ? JSON.parse(atob(data)) : null
const existingAbility = userData?.ability ?? null

export default createMongoAbility(existingAbility || initialAbility)
